import * as S from "../styles";

function StatusCorrida({ corrida, status, trajeto }) {
  const situacao = (s, c) => {
    switch (s) {
      case "CORRIDA_PENDENTE":
        return "Procurando Motorista";
      case "CORRIDA_EM_ANDAMENTO":
        return corridaEmAndamento(c);
      case "CORRIDA":
        return corridaEmAndamento(c);
      default:
        return s;
    }
  };

  const corridaEmAndamento = (c) => {
    if (!c.dataHoraQrl) {
      return "Motorista a Caminho";
    }
    if (!c.dataHoraQrv) {
      return statusDestino(c) || "A caminho do destino";
    } else {
      return "Corrida Finalizada";
    }
  };

  const statusDestino = (c) => {
    let d = c.destinos || [];
    for (let i = 0; i < d.length; i++) {
      const destino = d[i];
      if (!destino.dataHoraQrv) {
        return `A caminho do destino ${i + 1}`;
      }
    }
  };

  const distTempo = (trajeto) => {
    if (!trajeto.duration) return "";
    let tempo = Math.ceil(trajeto.duration / 60) + " min";
    let distancia = trajeto.distance > 1000 ? Math.ceil(trajeto.distance / 1000) + " km" : Math.ceil(trajeto.distance) + " m";
    return (
      <S.StatusCorridaItem>
        Tempo estimado: <span>{tempo}</span> - <span>{distancia}</span>
      </S.StatusCorridaItem>
    );
  };

  return (
    <S.StatusCorrida>
      <S.StatusCorridaItem>{situacao(status, corrida)}</S.StatusCorridaItem>
      {distTempo(trajeto)}
    </S.StatusCorrida>
  );
}
export default StatusCorrida;
